import React, {useEffect} from "react";
import EmailInput from "../../elements/EmailInput";
import TextInput from "../../elements/TextInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {InputAdornment} from "@mui/material";
import IconButton from "@mui/material/IconButton/IconButton.js";
import {Button} from "@mui/material";
import {useDispatch} from "react-redux";
import {resendVerificationEmail} from "../../../redux/user/Action";
import {REGISTER, STEPS} from "./constants";
import {isEmpty} from "weed-js";


export const Register = ({formState, setFormState, errors, setErrors, showPassword, setShowPassword, loggedInUser, userProfile}) => {
    const dispatch = useDispatch();
    const [shouldVerifyDialog, setShouldVerifyDialog] = React.useState(null);

    useEffect(() => {
        if (loggedInUser && userProfile) {
            if (!userProfile?.email_is_verified) {
                setShouldVerifyDialog(<div className={"create-account-register"}>
                    <h2>Email Verification Required</h2>
                    <p>
                        You have already registered an account with us, but you need to verify your email address before
                        you can proceed.
                        Please check your inbox for a verification email.
                    </p>
                    <Button onClick={() => {
                        dispatch(resendVerificationEmail(
                            formState
                        ));
                    }}>Re-send Verification Email</Button>
                </div>);
            }
        }
    }, [loggedInUser, userProfile]);

    return <div className={"create-account-register"}>
        <h2>What is your Email?</h2>
        <form>
            {shouldVerifyDialog}
            <EmailInput
                name={"email"}
                label={"Email Address"}
                formState={formState}
                setFormState={setFormState}
                errors={errors}
                setErrors={setErrors}
                disabled={!isEmpty(loggedInUser)}
            />
            {/*<TextInput*/}
            {/*    name={"first_name"}*/}
            {/*    label={"First Name"}*/}
            {/*    formState={formState}*/}
            {/*    setFormState={setFormState}*/}
            {/*    errors={errors}*/}
            {/*    setErrors={setErrors}*/}
            {/*    disabled={!isEmpty(loggedInUser)}*/}
            {/*/>*/}
            {/*<TextInput*/}
            {/*    name={"last_name"}*/}
            {/*    label={"Last Name"}*/}
            {/*    formState={formState}*/}
            {/*    setFormState={setFormState}*/}
            {/*    errors={errors}*/}
            {/*    setErrors={setErrors}*/}
            {/*    disabled={!isEmpty(loggedInUser)}*/}
            {/*/>*/}
            {/*<TextInput*/}
            {/*    name={"password"}*/}
            {/*    label={"Password"}*/}
            {/*    type={showPassword ? "input" : "password"}*/}
            {/*    formState={formState}*/}
            {/*    setFormState={setFormState}*/}
            {/*    errors={errors}*/}
            {/*    setErrors={setErrors}*/}
            {/*    disabled={!isEmpty(loggedInUser)}*/}
            {/*    InputProps={{*/}
            {/*        endAdornment: (*/}
            {/*            <InputAdornment position={"end"}>*/}
            {/*                <IconButton*/}
            {/*                    aria-label="toggle password visibility"*/}
            {/*                    onClick={() => setShowPassword(!showPassword)}*/}
            {/*                    onMouseDown={(event) => event.preventDefault()}*/}
            {/*                    edge={"end"}*/}
            {/*                >*/}
            {/*                    {showPassword ? <VisibilityOff/> : <Visibility />}*/}
            {/*                </IconButton>*/}
            {/*            </InputAdornment>*/}
            {/*        )*/}
            {/*    }}*/}
            {/*/>*/}
            {/*<TextInput*/}
            {/*    name={"confirm_password"}*/}
            {/*    label={"Confirm Password"}*/}
            {/*    type={showPassword ? "input" : "password"}*/}
            {/*    formState={formState}*/}
            {/*    setFormState={setFormState}*/}
            {/*    errors={errors}*/}
            {/*    disabled={!isEmpty(loggedInUser)}*/}
            {/*    setErrors={setErrors}*/}
            {/*    InputProps={{*/}
            {/*        endAdornment: (*/}
            {/*            <InputAdornment position={"end"}>*/}
            {/*                <IconButton*/}
            {/*                    aria-label="toggle password visibility"*/}
            {/*                    onClick={() => setShowPassword(!showPassword)}*/}
            {/*                    onMouseDown={(event) => event.preventDefault()}*/}
            {/*                    edge={"end"}*/}
            {/*                >*/}
            {/*                    {showPassword ? <VisibilityOff/> : <Visibility />}*/}
            {/*                </IconButton>*/}
            {/*            </InputAdornment>*/}
            {/*        )*/}
            {/*    }}*/}
            {/*/>*/}
        </form>
    </div>;
};


export default Register;
